export default __webpack_public_path__ + "static/media/alphaGreenLogo.84c1594b.svg";